// Houdt de blur-laag achter het mega menu in sync met de hover/focus-state.
// De blur zelf kan niet met opacity gefade worden (backdrop-filter blijft dan
// hard aan/uit springen), dus animeren we de blur-radius via data-blur.
const BLUR_DURATION = 500

// Ruimte die we onder de cards vrijhouden zodat het menu niet strak tegen de
// viewportrand aanplakt, zelfs op de kortste schermen.
const CARDS_BOTTOM_GUTTER = 32
const CARDS_MIN_IMAGE_HEIGHT = 56

/**
 * Krimpt de card-images in een mega menu zodat het volledige grid binnen de
 * viewport blijft op platte/korte schermen, zonder de standaardhoogte aan te
 * raken zolang er genoeg ruimte is.
 *
 * De rest van de card (divider + label) blijft op zijn eigen hoogte staan;
 * enkel de image krimpt. `object-cover` zorgt dat de foto netjes blijft
 * vullen.
 */
const fitCards = (item) => {
    const cardsGrid = item.querySelector('[data-mega-menu-cards]')

    if (!cardsGrid) return

    const images = Array.from(cardsGrid.querySelectorAll('img'))

    if (images.length === 0) return

    // Terug naar de intrinsieke maat: anders meten we onze eigen vorige
    // shrink in plaats van de ruimte die de cards nu echt nodig hebben.
    images.forEach((image) => {
        image.style.height = ''
    })

    const availableHeight =
        window.innerHeight -
        cardsGrid.getBoundingClientRect().top -
        CARDS_BOTTOM_GUTTER

    if (cardsGrid.scrollHeight <= availableHeight) return

    // Rijen tellen via de top-positie van elke image in plaats van een
    // hardcoded kolomaantal, zodat dit blijft kloppen als het grid ooit een
    // ander aantal kolommen krijgt.
    const firstTop = Math.round(images[0].getBoundingClientRect().top)
    const columns = images.filter(
        (image) => Math.round(image.getBoundingClientRect().top) === firstTop
    ).length
    const rows = Math.ceil(images.length / columns)

    const naturalImageHeight = images[0].getBoundingClientRect().height

    // Grootste "chrome" (alles op de card behalve de image) over alle cards:
    // een label van twee regels heeft meer ruimte nodig dan de rest, en die
    // ruimte moet voor elke rij gereserveerd blijven.
    const chrome = Array.from(cardsGrid.children).reduce((max, card) => {
        const image = card.querySelector('img')

        return image
            ? Math.max(
                  max,
                  card.getBoundingClientRect().height -
                      image.getBoundingClientRect().height
              )
            : max
    }, 0)

    const rowGap = parseFloat(getComputedStyle(cardsGrid).rowGap) || 0

    const targetImageHeight = Math.max(
        CARDS_MIN_IMAGE_HEIGHT,
        (availableHeight - rows * chrome - (rows - 1) * rowGap) / rows
    )

    if (targetImageHeight >= naturalImageHeight) return

    images.forEach((image) => {
        image.style.height = `${targetImageHeight}px`
    })
}

const setup = (item) => {
    const blur = item.querySelector('[data-mega-blur]')

    if (!blur) return

    let removeTimer = null

    const open = () => {
        clearTimeout(removeTimer)

        fitCards(item)

        if (blur.dataset.blur === 'on') return

        // Startwaarde zetten en de style forceren, anders heeft de browser
        // geen beginpunt om vanaf te animeren.
        blur.dataset.blur = 'off'
        void blur.offsetWidth
        blur.dataset.blur = 'on'
    }

    const close = () => {
        if (!blur.dataset.blur) return

        blur.dataset.blur = 'off'

        // Pas na de fade-out helemaal weghalen, zodat er in rust geen
        // backdrop-filter meer actief is.
        clearTimeout(removeTimer)
        removeTimer = setTimeout(() => {
            delete blur.dataset.blur
        }, BLUR_DURATION)
    }

    item.addEventListener('mouseenter', open)
    item.addEventListener('mouseleave', close)
    item.addEventListener('focusin', open)
    item.addEventListener('focusout', (event) => {
        if (item.contains(event.relatedTarget)) return

        close()
    })
}

const initMegaMenu = () => {
    const items = document.querySelectorAll('.js-mega-menu')

    items.forEach(setup)

    let resizeTimer = null

    // Alleen het menu dat effectief open staat herberekenen: de rest heeft
    // toch geen zichtbaar effect en scheelt onnodig veel layout-reads.
    // window.addEventListener('resize', () => {
    //     clearTimeout(resizeTimer)
    //     resizeTimer = setTimeout(() => {
    //         items.forEach((item) => {
    //             const blur = item.querySelector('[data-mega-blur]')

    //             if (blur && blur.dataset.blur === 'on') {
    //                 fitCards(item)
    //             }
    //         })
    //     }, 150)
    // })
}

export { initMegaMenu }
